import React, { useEffect, useRef, useState } from 'react';
import Chat from './Chat';
import Pdfgenerator from './Pdfgenerator';
import Modal from './Modal';
import { useAuth } from './AuthContext';
import useSendMessages from './hooks/useSendMessages';
import useFileUpload from './hooks/useFileUpload';
import axios from "axios";
import UploadedImages from "./UploadedImages";
import ChatInput from "./ChatInput";
import API_URL from './config/apiConfig';

const ChatContainer = () => {
    const { authToken } = useAuth();
    const [inputValue, setInputValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const defaultMessage = {
        role: "assistant",
        content: "Bonjour, je suis SophIA, l'assistante qui vous accompagne dans la tentative de résolution des dommages qui affectent le bien de votre client.\n\n" +
            "Pour m\'aider à comprendre au mieux la situation et procéder efficacement à l\'élaboration d\'un pré-rapport, pourriez-vous me fournir une description détaillée de ce " +
            "qu\'il s'est passé ?\n\n" +
            "Veuillez inclure, si possible, les circonstances menant à l'incident, les dommages observés et toute autre information que vous jugerez pertinente.\n\n"
    };
    const [sentImageUrls, setSentImageUrls] = useState([]);
    const [messages, setMessages] = useState([defaultMessage]);
    const messagesEndRef = useRef(null);
    const { uploadedImageUrls, setUploadedImageUrls, handleImageChange, removeFile, largeImageUrls } = useFileUpload();

    const userId = authToken.userId;
    const [showModal, setShowModal] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [isOver, setIsOver] = useState(false);
    const [generatedPDF, setGeneratedPDF] = useState(null);
    const [pdfStats, setPdfStats] = useState({});
    const { handleSend, error } = useSendMessages(
        inputValue,
        setInputValue,
        setIsLoading,
        setSentImageUrls,
        setUploadedImageUrls,
        uploadedImageUrls,
        messages,
        setMessages
    );

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, messagesEndRef]);

    useEffect(() => {
        // Appel à l'API pour récupérer les statistiques de génération de PDF
        const fetchPdfStatus = async () => {
            try {
                // Utilisation du nouvel endpoint pour récupérer toutes les statistiques
                const response = await axios.get(`${API_URL}/user-pdf-stats/${userId}`);

                if (response.data && response.data.success) {
                    // On récupère les statistiques complètes
                    const { used, remaining, total } = response.data.data;

                    // Si vous avez besoin de stocker ces informations dans l'état
                    setPdfStats({
                        used,
                        remaining,
                        total
                    });

                    // Si vous avez besoin de maintenir la compatibilité avec l'ancien état generatedPDF
                    setGeneratedPDF(used);

                    console.log(`Générations utilisées: ${used}, Restantes: ${remaining}, Total: ${total}`);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des statistiques PDF :', error);
            } finally {
                console.log('Récupération des statistiques PDF terminée');
            }
        };

        if (userId) {
            fetchPdfStatus();
        }
    }, [userId]);

    return (
        <div className="pt-10 lg:pt-14 m-auto min-h-screen w-full background">
            <Chat
                messages={messages}
                messagesEndRef={messagesEndRef}
                isLoading={isLoading}
            />

            <UploadedImages
                uploadedImageUrls={uploadedImageUrls}
                largeImageUrls={largeImageUrls}
                removeFile={removeFile}
            />

            <ChatInput
                inputValue={inputValue}
                setInputValue={setInputValue}
                handleSend={handleSend}
                handleImageChange={handleImageChange}
                pdfStats={pdfStats}
                messages={messages}
                sentImageUrls={sentImageUrls}
                setShowForm={setShowForm}
                setShowModal={setShowModal}
                setIsOver={setIsOver}
            />

            {showModal && <Modal onClose={() => setShowModal(false)} />}
        </div>
    );
};

export default ChatContainer;